import React from "react";
import GeeComLogo from "../Images/glogo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E1F22] text-white py-4 px-6  flex justify-between items-center">
      <div className="flex items-center space-x-3 ">
        <img src={GeeComLogo} alt="GeeCom Logo" className="w-[70px] h-auto" />
        <span className="text-white-500 text-base">
          Made in India by GeeCom India
        </span>
      </div>
      <div className="text-sm text-white mr-16">
        Copyright © GeeCom India {currentYear}
      </div>
    </footer>
  );
};

export default Footer;
